export default {
      id: "maintenance_tracking-usage",
      viewBox: "0 0 40 38",
      url: __webpack_public_path__ + "img/icons.svg#maintenance_tracking",
      toString: function () {
        return this.url;
      }
    }